import React from 'react'; 
import './Background.css';
   
function Background() { 
  return ( 
    <div class="background">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      {/* <span></span>
      <span></span> */}
    </div>
  ); 
} 
   
export default Background; 